import { render } from "./SpinnerSec.vue?vue&type=template&id=0a6338e2&scoped=true"
import script from "./SpinnerSec.vue?vue&type=script&lang=js"
export * from "./SpinnerSec.vue?vue&type=script&lang=js"

import "./SpinnerSec.vue?vue&type=style&index=0&id=0a6338e2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a6338e2"]])

export default __exports__